@if (proposals && proposals?.length && enabled) {
  <app-send-proposals-modal
    [proposals]="proposals"
    (proposalsSent)="refreshTaskDetails()"
  >
    <app-arrow-right-icon
      height="16px"
      width="16px"
      color="var(--brand-500)"
      ngbTooltip="Envoyer les offres"
      i18n-ngbTooltip
    />
  </app-send-proposals-modal>
}
